import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Home() {
  const homeSchemaData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '萝卜视频 - 智能AI视频创作平台',
      description: '萝卜视频是一款专为创作者打造的智能视频工具，支持一键生成、剪辑、配音与字幕。',
      url: 'https://luoboshipin.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '萝卜视频',
        url: 'https://luoboshipin.com/',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '萝卜视频适合哪些人群使用？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '萝卜视频适合所有需要制作视频内容的用户，包括短视频创作者、自媒体运营者、企业营销人员、教育培训机构、电商卖家等。',
          },
        },
        {
          '@type': 'Question',
          name: '萝卜视频的AI配音效果怎么样？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '萝卜视频的AI配音基于最新的深度学习语音合成技术，支持超过50种语言和200多种声音风格，配音效果非常自然流畅。',
          },
        },
        {
          '@type': 'Question',
          name: '使用萝卜视频需要下载安装吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '萝卜视频提供网页版和桌面客户端两种使用方式。网页版无需下载安装，直接在浏览器中使用全部功能。',
          },
        },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: '萝卜视频',
      applicationCategory: 'MultimediaApplication',
      operatingSystem: 'Web, Windows, macOS',
      description: '智能AI视频创作平台，支持一键生成、剪辑、配音与字幕。',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'CNY',
      },
    },
  ];

  const featuredArticles = articles.slice(0, 4);

  return (
    <>
      <SEOHead
        title="萝卜视频 - 智能AI视频创作平台 | 一键生成剪辑配音字幕"
        description="萝卜视频是一款专为创作者打造的智能视频工具，支持一键生成、剪辑、配音与字幕，让每个人都能轻松制作专业级视频内容。立即体验萝卜视频，解锁高效视频创作新方式。"
        keywords="萝卜视频,萝卜视频怎么用,萝卜视频AI剪辑,萝卜视频下载,萝卜视频创作教程,智能视频生成工具,一键视频剪辑软件"
        canonicalUrl="https://luoboshipin.com/"
        schemaData={homeSchemaData}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />

        <section className="w-full py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                    最新文章
                  </h2>
                  <p className="text-foreground-600 text-sm">学习AI视频创作技巧，了解行业最新动态</p>
                </div>
                <Link
                  to="/articles"
                  className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {featuredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/articles/${article.slug}`}
                    className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                  >
                    <div className="aspect-video w-full overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-4">
                      <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                        {article.category}
                      </span>
                      <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-foreground-400">
                        <span>{article.publishedAt}</span>
                        <span>{article.readTime} 分钟阅读</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}